import { render } from "./CalendarEvents.vue?vue&type=template&id=57f1b050&scoped=true&ts=true&lang=pug"
import script from "./CalendarEvents.vue?vue&type=script&lang=ts"
export * from "./CalendarEvents.vue?vue&type=script&lang=ts"

import "./CalendarEvents.vue?vue&type=style&index=0&id=57f1b050&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f1b050"]])

export default __exports__